<mat-card>
  <mat-card-title>
    Catégories des pièces jointes
  </mat-card-title>
  <mat-card-content>
    <div fxLayout="column">
      <div fxLayoutAlign="end">
        <mat-card-actions align="end">
          <button mat-raised-button (click)="addType()" routerLinkActive="true"
                  aria-disabled="false" color="accent"
                  matTooltipPosition="right" matTooltip="Ajouter une nouvelle catégorie">
            <i class="fa fa-plus"></i> Nouvelle
          </button>
        </mat-card-actions>
      </div>
    </div>
    <app-data-table [dataSource]="pjTemplateTypeSource"
                    [columns]="columns"
                    [actions]="actions"
                    [pageSize]="5" [pageSizesList]="[5,10,25]"
                    [filterDisplay]="false"
                    [showLoader]="true"
                    [refreshIcone]="false"
                    [loaderMask]="false">
    </app-data-table>
  </mat-card-content>
</mat-card>
